<template>
    <Modal :title="$t('common.downloadAssignmentDocuments.modal.title')"
           :close-on-click-outside="false"
           @close="closeModal"
    >
        <template v-slot:body>
            <form class="flex flex_column base_margin modal-content" style="margin-top: 0">
                <DatePicker v-on:input="changeDate"
                            :value="form.dateRange"
                            :placeholder="$t('common.assignmentDate')"
                            type="daterange"
                ></DatePicker>
                <div class="flex flex_column margin_vertical">
                    <md-checkbox v-model="form.documents.needAssignment">
                        {{ localizeDocumentType(enumDef.assignmentDocumentType.AssignmentContract) }}
                    </md-checkbox>
					<md-checkbox v-model="form.documents.needAdditionalAssignment">
						{{ localizeDocumentType(enumDef.assignmentDocumentType.AssignmentAdditionalDocument) }}
					</md-checkbox>
                    <md-checkbox v-model="form.documents.needAdviceOfSettlement">
                        {{ localizeDocumentType(enumDef.assignmentDocumentType.AdviceOfSettlement) }}
                    </md-checkbox>
                    <md-checkbox v-model="form.documents.needServiceInvoice">
                        {{ localizeDocumentType(enumDef.assignmentDocumentType.ServiceInvoice) }}
                    </md-checkbox>
					<md-checkbox v-model="form.documents.needDiscountInvoice">
						{{ localizeDocumentType(enumDef.assignmentDocumentType.DiscountInvoice) }}
					</md-checkbox>
                    <md-checkbox v-model="form.documents.needCsv">
                        {{ localizeDocumentType(enumDef.assignmentDocumentType.AccountingCsv) }}
                    </md-checkbox>
                </div>
                <md-checkbox v-model="form.documents.needInvoice">
                    {{ $t("ReportCsvModal.Include") }}
                </md-checkbox>
            </form>
            <div class="flex flex_between base_margin">
                <md-button class="md-blank" @click="closeModal">
                    {{$t("common.button.close")}}
                </md-button>
                <md-button class="opacity_5" :class="{ 'md-primary': submitBtnStatus }" @click="download">
                    {{$t("common.download")}}
                </md-button>
            </div>
        </template>
    </Modal>
</template>

<script>
import DatePicker from "@/components/templates/DatePicker";
import Modal from "@/components/templates/modal/Modal";
import {enumDef} from "@/common/enumDefs";
import {formatAsLocalizedEnum} from "@/common/format";
import {allReceivablesApi} from "@/common/api/allReceivablesApi";

export default {
    props: {
        accountId: { type: Number }
    },
    components: {
        Modal,
        DatePicker
    },
    data() {
        return {
            enumDef: enumDef,
            form: {
                dateRange: ["", ""],
                documents: {
                    needAssignment: true,
					needAdditionalAssignment: true,
                    needAdviceOfSettlement: true,
                    needServiceInvoice: true,
	                needDiscountInvoice: true,
                    needCsv: true,
                    needInvoice: true
                }
            },
        };
    },
    computed: {
        submitBtnStatus() {
            return this.form.dateRange.every(value => value !== "");
        }
    },
    methods: {
        download() {
            if (!this.submitBtnStatus) {
                return;
            }

            let option = {
                forSell: true,
                batchStartDate: this.form.dateRange[0],
                batchEndDate: this.form.dateRange[1],
                ...this.form.documents
            };

			allReceivablesApi.downloadAllDocuments(option)
                .then(res => {
                    this.closeModal();
					window.open(res.msg, '_blank');
                })
                .catch(err => {
                    this.toast(err);
                });
        },
        closeModal() {
            this.$emit("close");
        },
        changeDate(dateRange) {
            this.form.dateRange = dateRange;
        },
        localizeDocumentType(type) {
            return formatAsLocalizedEnum(enumDef.assignmentDocumentType, type);
        },
    }
};
</script>
